import { render, staticRenderFns } from "./main-surgery.vue?vue&type=template&id=52bd37e5&scoped=true"
import script from "./main-surgery.vue?vue&type=script&lang=js"
export * from "./main-surgery.vue?vue&type=script&lang=js"
import style0 from "./main-surgery.vue?vue&type=style&index=0&id=52bd37e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bd37e5",
  null
  
)

export default component.exports